/**
 * Videos
 * ======================================
 * - play videos in viewport
 * - pause videos outside viewport
 */

 const ELEMENTS = '.js-videos'

 class Videos {
   constructor() {
     this.sections = document.querySelectorAll(ELEMENTS)

     window.addEventListener('scroll', this.scrollHandler, false)

     this.scrollHandler()
   }

   scrollHandler = () => {
     for (const section of this.sections) {
       const videos = section.querySelectorAll('video')

       if (
         -section.getBoundingClientRect().top <= section.getBoundingClientRect().height &&
         !section.parentNode.hasAttribute('hidden')
       ) {
         for (const video of videos) {
           video.play()
           video.classList.add('playing')
         }
       } else {
         for (const video of videos) {
           video.pause()
           video.classList.remove('playing')
         }
       }
     }
   }
 }

 new Videos()
